  
import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main' 
import NewMain from '../headerone/newMain'
 
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
 

function CorporateLaison() {

    const notificationList = [
       
        {
            title: "MOU with Sarvodaya Hospital, Faridabad",
            src: "assets/img/new_images/sarvodaya.jpg", // replace with actual image path
            link: "/mou-sarvodaya-faridabad",    // replace with actual route or URL
            description: "MVN University, Palwal and Sarvodaya Hospital, Faridabad have inked an MOU. Thrilled to embark on this collaborative journey towards excellence in pharmaceutical education and healthcare."
        },
        {
            title: "MOU with the NBPGR, ICAR",
            src: "assets/img/new_images/nbpgr.jpg", // replace with actual image path
            link: "/mou-nbpgr-icar",         // replace with actual route or URL
            description: "MVN University has added another feather to its cap by signing a Memorandum of Understanding (MOU) with the National Bureau of Plant Genetic Resources (NBPGR), Indian Council of Agricultural Research (ICAR), New Delhi."
        },
  {
    title: "MoU with CFC Pharma Cluster Pvt Ltd, Karnal",
    src: "assets/img/new_images/mou-cfc-karnal.jpg",
    link: "/mou-cfc-pharma-karnal",
    description: "MVN University, Palwal, achieves another milestone with a successful MoU with CFC Pharma Cluster Pvt Ltd, Karnal. This collaboration opens doors for impactful research projects and enriching training opportunities for our dedicated faculty members and students."
  },
  {
    title: "MoU with Nestlé to Launch On-Campus Café",
    src: "assets/img/new_images/mou-nestle.jpg",
    link: "/mou-nestle-cafe",
    description: "MVN University has signed a Memorandum of Understanding (MoU) with Nestlé to open a Nestlé Café on campus. The café aims to create a vibrant and welcoming space for students, faculty, and staff, encouraging relaxation, informal interaction, and community building."
  },
  {
    title: "MoU with Apna Blood Bank, Palwal",
    src: "assets/img/new_images/mou-apna-bloodbank.jpg",
    link: "/mou-apna-bloodbank",
    description: "MVN University signed an MoU with Apna Blood Bank on January 2024. The partnership aims to promote regular blood donation camps and health awareness."
  },
  {
    title: "MoU with AGISS Research Institute, Noida",
    src: "assets/img/new_images/mou-agiss.jpg",
    link: "/mou-agiss-noida",
    description: "MVN University signed an MoU with AGISS Research Institute, Noida on 18 June, 2022. The agreement aims to promote collaborative research and academic development. It provides students with opportunities for innovation and practical exposure."
  },
  {
    title: "MoU with CFC Pharma Cluster Pvt Ltd, Karnal",
    src: "assets/img/new_images/mou-cfc2-karnal.jpg",
    link: "/mou-cfc2-karnal",
    description: "MVN University, Palwal signed an MoU with CFC Pharma Cluster Pvt. Ltd., Karnal on 16 December 2023 to strengthen pharmaceutical education. It aims to enhance research, innovation, and hands-on training in pharmaceutical sciences."
  }, {
            title: "MOU with THSTI, Faridabad",
            src: "assets/img/new_images/notificationList_dummy.jpg", // replace with actual image path
            link: "/mou-thsti-faridabad",    // replace with actual route or URL
            description: "On 18th November 2024, MVN University signed a significant Memorandum of Understanding (MoU) with the Translation Health Science and Technology Institute (THSTI), Faridabad. This collaboration aims to facilitate advanced research opportunities and bridge academic and industrial gaps for students and faculty. MoU Signed: Strengthening Education-Industry Partnerships."
        },
  {
    title: "MoU with Ahuja Eye & Dental Institute, Gurugram",
    src: "assets/img/new_images/mou-ahuja.jpg",
    link: "/mou-ahuja-gurugram",
    description: "In January 2025, MVN University signed an MoU with Ahuja Eye & Dental Institute, Gurugram. The collaboration aims to enhance education and research in healthcare and medical sciences."
  }


        ];

        

  const options = {
    margin: 10,
    responsiveClass: true,
    nav: false,
    dots: true,
    loop: true,
    autoplay: false,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 2,
      },
    },
  };


    return (
        <>
            <NewMain />
            <Bredcom title="Home" subtitle=" 	Corporate Laison " />


            <section className="project-detail">
                <div className="container">
                  <div className='text-center tcrctitle'>
                    <h2>Corporate Laison </h2>
                  </div>
                <br />
                <div className='corprortae_lis_carosal'>
                    
                    <OwlCarousel className='owl-theme' loop margin={10} nav {...options}>
                         
                    
                        {notificationList.map((item, index) => (
                            <div className="item" key={index}>
                              <div className="corprortae_lis_carosal_one">
                                  <div class="corprortae_lis_carosal_one_img">
                                      <img src={item.src} alt={item.title} className="img-fluid" />
                                  </div>
                    
                                  <div class="corprortae_lis_carosal_one_content">
                                    <h4>{item.title}  </h4>
                                    <p> {item.description}  </p>
                                  </div>
                     
                              </div>
                            </div>
                          ))}
                    
                        
                        </OwlCarousel>;
                </div>

                <div className='corprortae_lis_table'>
                        <table class="table table-striped table-bordered"  style={{ tableLayout: "fixed", width: "100%" }}>
                            <thead class="thead-dark">
                                <tr> 
                                    <th style={{ width: "100px" }}>SR. NO.</th>
                                    <th>DATE</th>
                                    <th>NAME (FIRST PARTY)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>1</td><td>03.03.2025</td><td>CODEVO ACADEMY PVT LTD, HYDERABAD</td></tr>
                                <tr><td>2</td><td>11.02.2025</td><td>UNIKAUSHAL</td></tr>
                                <tr><td>3</td><td>18.11.2024</td><td>TRANSLATIONAL HELATH SCIENCE AND TECHNOLOGY INSTITUTE</td></tr>
                                <tr><td>4</td><td>26.12.2024</td><td>SATYAM PETRO  CHEMICAL </td></tr>
                                <tr><td>5</td><td>30.12.2024</td><td>NESTLE INDIA LTD</td></tr>
                                <tr><td>6</td><td>21.10.2024</td><td>BUNCH MICROTECHNOLOGIES PVT. LTD.</td></tr>
                                <tr><td>7</td><td>09.10.2024</td><td>DIVINE CHARITABLE BLOOD BANK</td></tr>
                                <tr><td>8</td><td>01.11.2023</td><td>GURU NANAK HOSPITAL PALWAL</td></tr>
                                <tr><td>9</td><td>22.07.2024</td><td>GRAYQUEST EDUCATION FINANCE PVT LTD</td></tr>
                                <tr><td>10</td><td>14.12.2023</td><td>SARVODAYA HOSPITAL & RESEARCH CENTRE</td></tr>
                                <tr><td>11</td><td>16.12.2023</td><td>CFC PHARMA CLUSTER PVT. LTD. KARNAL</td></tr>
                                <tr><td>12</td><td>02.05.2024</td><td>SAMATRIX CONSULTING PVT LTD</td></tr>
                                <tr><td>13</td><td>00.01.2024</td><td>APNA BLOOD BANK PALWAL</td></tr>
                                <tr><td>14</td><td>00.01.2024</td><td>K C PRASHANT LAB PALWAL</td></tr>
                                <tr><td>15</td><td>00.01.2024</td><td>AHOOJA EYE AND DENTAL INSTITUTE GURUGRAM</td></tr>
                                <tr><td>16</td><td>09.11.2023</td><td>ICAR NATINAL BUREAU OF PLANT GENETIC RESOURCES NEW DELHI</td></tr>
                                <tr><td>17</td><td>08.09.2023</td><td>ADORN ENVIRNMENTAL SERVICES FARIDABAD</td></tr>
                                <tr><td>18</td><td>14.12.2022</td><td>AGRO ENVIRONMRNT EDUCATION & FARMERS WELFARE SOCIETY HOSIARPUR PUNJAB</td></tr>
                                <tr><td>19</td><td>14.12.2022</td><td>JUST AGRICULTURE HOSIYARPUR PANJAB</td></tr>
                                <tr><td>20</td><td>22.06.2022</td><td>SORTING HAT TECHNOLOGIES PVT LTD</td></tr>
                                <tr><td>21</td><td>18.06.2022</td><td>AGISS RESEARCH INSTITUTE</td></tr>
                                <tr><td>22</td><td>04.05.2022</td><td>WEGROW LLP,D-13 KIIMS, BHUBANESWAR ODISHA</td></tr>
                                <tr><td>23</td><td>21.10.2021</td><td>GITHUB</td></tr>
                                <tr><td>24</td><td>24.08.2021</td><td>GOPLOH VENTURES PVT. LTD. FARIDABAD</td></tr>
                                <tr><td>25</td><td>22.07.2021</td><td>VN ORGANICS PVT. LTD. GWALIOR M.P.</td></tr>
                                <tr><td>26</td><td>08.09.2020</td><td>DENTSU AEGIS NETWORK (POWER OF YOUTH)</td></tr>
                                <tr><td>27</td><td>24.07.2020</td><td>BLUE TIE GLOBAL PVT LTD</td></tr>
                                <tr><td>28</td><td>14.07.2020</td><td>ANUDIP FONDATION FOR SOIAL WELFARE</td></tr> 
                                <tr><td>29</td><td>09.01.2019</td><td>OM LOGISTICS LTD</td></tr>
                                <tr><td>30</td><td>25.07.2019</td><td>RUBICON SKILL DEVELOPMENT PVT LTD</td></tr>
                                <tr><td>31</td><td>18.05.2019</td><td>SKILL CLOUT'S </td></tr>
                                <tr><td>32</td><td>16.05.2019</td><td>MAHARISHI AYURVEDA </td></tr>
                                <tr><td>33</td><td>01.06.2019</td><td>K C PRASHANT LAB PALWAL</td></tr>
                            </tbody>
                        </table>


                </div>
                     
                </div>
            </section>
        </>
    )
}

export default CorporateLaison